<script setup lang="ts">
import { NConfigProvider, NMessageProvider, NNotificationProvider, NDialogProvider } from 'naive-ui'
import { themeOverrides } from './theme'
import { useRoute } from 'vue-router'
import { computed } from 'vue'
import AppShell from './components/AppShell.vue'

const route = useRoute()
const useShell = computed(() => route.meta.layout !== 'blank')
</script>

<template>
  <NConfigProvider :theme-overrides="themeOverrides">
    <NMessageProvider>
      <NNotificationProvider>
        <NDialogProvider>
          <AppShell v-if="useShell">
            <router-view />
          </AppShell>
          <router-view v-else />
        </NDialogProvider>
      </NNotificationProvider>
    </NMessageProvider>
  </NConfigProvider>
</template>

<style>
body {
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  margin: 0;
  background: #f5f6f7;
}
</style>
